var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var events = {
    start: "captureServicePreorder.start",
    change: "captureServicePreorder.change",
    clear: "captureServicePreorder.clear",
    stepChange: "captureServicePreorder.stepChange",
};
var funcs = {};
function broadcast(eventType, data) {
    var event;
    if (eventType === "start") {
        var orderId = data;
        event = new CustomEvent(events.start, {
            detail: {
                orderId: orderId,
            },
        });
    }
    else {
        event = new CustomEvent(events[eventType], data ? { detail: __assign({}, data) } : null);
    }
    document.dispatchEvent(event);
}
function listen(eventType, callback) {
    funcs[eventType] = callback;
    document.addEventListener(events[eventType], callback);
}
function remove(eventType) {
    document.removeEventListener(events[eventType], funcs[eventType]);
}
export default {
    broadcast: broadcast,
    listen: listen,
    remove: remove,
};
